import { faCakeCandles, faCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DateTime } from 'luxon'
import React from 'react'
import { Link } from 'react-router-dom'
import { ProgramAttendee } from '@citruscamps/citrus-client'
import { ROUTES } from '../../../../../constants/routes'
import { formatFullName } from '../../../../../utils/formatters'
import { AttendeeGenderSymbol } from '../../../../Attendees/pages/ManageAttendees/components/AttendeeGenderSymbol'

interface IProps {
  attendee: ProgramAttendee
}

export const CelebrationRow = ({ attendee }: IProps): React.ReactElement => {
  const dateOfBirth: DateTime | undefined = attendee.date_of_birth
    ? DateTime.fromISO(attendee.date_of_birth)
    : undefined

  return (
    <div className="list-group-item">
      <div className="d-flex mb-4">
        <div className="me-5 mt-3">
          <div className="rounded circle inline-block fa-layers fa-fw fa-xl me-3">
            <FontAwesomeIcon icon={faCircle} size="2x" className="rounded text-primary" />
            <FontAwesomeIcon
              icon={faCakeCandles}
              className="text-white"
              style={{ transform: 'translate(9px, 0)' }}
            />
          </div>
        </div>
        <div className="col">
          <Link
            className={attendee.is_archived ? 'text-body-secondary' : 'text-body'}
            to={ROUTES.ATTENDEE_DETAILS.replace(':id', attendee.id || '')}
          >
            <div className="my-1">
              {formatFullName(attendee) || (
                <span className="text-body-secondary">Name not provided</span>
              )}
              <AttendeeGenderSymbol attendee={attendee} />
            </div>
          </Link>
          <div className="text-body-secondary small">
            {dateOfBirth?.toFormat('LLLL d')} - Happy Birthday!
          </div>
        </div>
      </div>
    </div>
  )
}
